(function () {
  // helper: remove text in parentheses
  const clean = str => str.split('(')[0].trim();

  // initial pass (in case theme hasn’t changed it yet)
  const titleEl = document.querySelector('.product-single__title');
  if (titleEl) titleEl.textContent = clean(titleEl.textContent);

  // keep it clean whenever variants change
  document.addEventListener('variant:changed', e => {
    if (!e.detail || !e.detail.variant) return;
    const el = document.querySelector('.product-single__title');
    if (el) el.textContent = clean(e.detail.variant.title);
  });
})();
